import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Loader, Dimmer } from 'semantic-ui-react';
import { Pie } from '@ant-design/charts';
import { GetReservationDistributionByAgentReport } from '../../../api/services/finance';
import { onError, onWarning } from '../../../components/shared/messages';
import moment from 'moment';
import { Currencies } from '../../../components/shared/currencies';

export const ReservationDistributionByAgentWidget = ({ HotelIds }) => {
	const [reportData, setReportData] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const currencyId =
		window.optima.user && window.optima.user.CurrentHotel
			? window.optima.user.CurrentHotel.MainCurrencyId
			: 2;
	const currencySymbol = Currencies[currencyId ? currencyId : 1].symbol;

	useEffect(() => {
		if (!HotelIds.length) return;

		(async () => {
			try {
				setIsLoading(true);
				let today = moment();
				let startDate = today.add(-30, 'days').startOf('day');
				const data = await GetReservationDistributionByAgentReport(
					HotelIds.reduce(
						(spec, val, idx) => {
							spec[`HotelIDs[${idx}]`] = val;
							return spec;
						},
						{
							StartDate: startDate.toISOString(),
							EndDate: moment().endOf('day').toISOString(),
						}
					)
				);
				setReportData(data);
			} catch (error) {
				error.status === 400 ? onWarning(error) : onError(error);
			} finally {
				setIsLoading(false);
			}
		})();
	}, [HotelIds]);

	const pieChartConfig = useMemo(() => {
		return {
			data: reportData,
			angleField: 'TotalIncome',
			colorField: 'Agent',
			redius: 0.6,
			legend: false,
			label: {
				type: 'inner',
				offset: '-40%',
				content: '{name} {percentage}',
				style: {
					fontSize: 12,
					textAlign: 'center',
				},
			},
			tooltip: {
				fields: ['Agent', 'TotalIncome', 'NoOfOrders'],
				formatter: function formatter(item) {
					return {
						name: item.Agent,
						value: `<div><b> ${item.TotalIncome.toFixed(
							2
						)} ${currencySymbol}</b>&nbsp;(${item.NoOfOrders})</div>`,
					};
				},
			},
			interactions: [{ type: 'pie-legend-active' }, { type: 'element-active' }],
		};
	}, [reportData]);

	return (
		<>
			{isLoading ? (
				<Dimmer active inverted>
					<Loader inline='centered' size='medium' />
				</Dimmer>
			) : (
				<div style={{ height: '100%' }}>
					<Pie {...pieChartConfig} />
				</div>
			)}
		</>
	);
};

ReservationDistributionByAgentWidget.propTypes = {
	HotelIds: PropTypes.array,
};
